/**
 * Generate print page URL with exterior/kitchen specifiers and applied products
 * 
 * URL format:
 * /print.html?exteriorSpec=...&kitchenSpec=...&appliedProducts=[[...],[...]]
 */
export function generatePrintUrl(vizDataByTab, exteriorAppliedProducts, kitchenAppliedProducts, floorPlanInfo) {
    const params = new URLSearchParams();

    // Add exterior specifier
    if (vizDataByTab?.exterior) {
        params.set('exteriorSpec', vizDataByTab.exterior.specifier || '');
        params.set('exteriorSel', vizDataByTab.exterior.sel || '');
    }

    // Add kitchen specifier
    if (vizDataByTab?.kitchen) {
        params.set('kitchenSpec', vizDataByTab.kitchen.specifier || '');
        params.set('kitchenSel', vizDataByTab.kitchen.sel || '');
    }

    // Add home info from floorPlanInfo
    if (floorPlanInfo) {
        params.set('homeName', floorPlanInfo.name || '');
        params.set('sqFt', floorPlanInfo.sqft?.toLocaleString() || '');
        params.set('bedrooms', String(floorPlanInfo.beds || ''));
        params.set('bathrooms', String(floorPlanInfo.bath || ''));
        params.set('garage', `${floorPlanInfo.garageCount || 0}-Car Attached Garage`);
    }

    // Build applied products array
    const appliedProducts = [];

    // Process exterior applied products
    if (exteriorAppliedProducts) {
        Object.entries(exteriorAppliedProducts).forEach(([surface, product]) => {
            if (product) {
                // For Stone/Brick surface, use the product's categoryName instead
                const displaySurface = surface === 'Stone/Brick' && product.categoryName 
                    ? product.categoryName 
                    : surface;
                    
                appliedProducts.push({
                    tab: 'exterior',
                    surface: displaySurface,
                    id: product.id,
                    name: product.name || '',
                    color: product.color || '',
                    warranty: product.warranty || ''
                });
            }
        });
    }

    // Process kitchen applied products
    if (kitchenAppliedProducts) {
        Object.entries(kitchenAppliedProducts).forEach(([surface, product]) => {
            if (product) {
                appliedProducts.push({
                    tab: 'kitchen',
                    surface: surface,
                    id: product.id,
                    name: product.name || '',
                    color: product.color || '',
                    warranty: product.warranty || ''
                });
            }
        });
    }

    // Add applied products as JSON array
    if (appliedProducts.length > 0) {
        params.set('appliedProducts', JSON.stringify(appliedProducts));
    }

    return `/print.html?${params.toString()}`;
}

/**
 * Open print page in new window
 */
export function openPrintPage(vizDataByTab, exteriorAppliedProducts, kitchenAppliedProducts, floorPlanInfo) {
    const url = generatePrintUrl(vizDataByTab, exteriorAppliedProducts, kitchenAppliedProducts, floorPlanInfo);
    if (url) {
        window.open(url, '_blank');
    }
}

/**
 * Parse applied products from URL query param
 */
export function parseAppliedProducts(appliedProductsParam) {
    if (!appliedProductsParam) return [];
    
    try {
        return JSON.parse(appliedProductsParam);
    } catch (e) {
        console.error('Error parsing appliedProducts:', e);
        return [];
    }
}
